import { Component, EventEmitter, Input, Output } from '@angular/core';
import { getFullName } from 'src/app/shared/utils/full-name.util';
import { PopupProfile } from '../profile-management.service';

@Component({
  selector: 'app-profile-mobile-invite-sent',
  templateUrl: './profile-mobile-invite-sent.component.html',
  styleUrls: ['./profile-mobile-invite-sent.component.scss'],
})
export class ProfileMobileInviteSentComponent {
  @Input() profileDetails!: PopupProfile;
  @Output() viewProfile = new EventEmitter<void>();
  @Output() addAnotherUser = new EventEmitter<void>();

  get userName(): string {
    return getFullName(this.profileDetails?.firstName, this.profileDetails?.middleName, this.profileDetails?.lastName);
  }
}
